import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
//进度条状态 默认normal
export type UploadProgressStatusType = 'success' | 'error' | 'active' | 'normal';

// const statusColorMap = new Map([
//   ['normal', '#388fff'],
//   ['exception', '#f24645'],
//   ['success', '#51bd78']
// ]);
@Component({
  selector: 'upload-progress',
  templateUrl: './upload-progress.component.html',
  styleUrls: ['./upload-progress.component.css']
})
export class UploadProgressComponent implements OnInit, OnChanges {
  //是否显示进度条信息
  @Input() showInfo: boolean = true;
  //进度条状态 默认'normal'
  @Input() status: UploadProgressStatusType;
  //已完成的分段百分比
  @Input() successPercent: number;
  @Input() percent = 0;
  @Input() maxWidth =0;
  //存储的状态
  private cachedStatus: UploadProgressStatusType = 'normal';
  //计算的状态
  private inferredStatus: UploadProgressStatusType = 'normal';

  //获得进度条状态
  get progressStatus(): UploadProgressStatusType {
    return this.status || this.inferredStatus;
  }
  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    const { status, percent, successPercent } = changes;
    //状态变化
    if (status) {
      this.cachedStatus = this.status || this.cachedStatus;
    }
    //进度 已完成的分段百分比 变化
    if (percent || successPercent) {
      const fillAll = parseInt(this.percent.toString(), 10) >= 100;
      if (fillAll) {
        if ((this.isNotNil(this.successPercent) && this.successPercent! >= 100) || this.successPercent === undefined) {
          this.inferredStatus = 'success';
          // this.status = this.inferredStatus;
        }
      } else {
        this.inferredStatus = this.cachedStatus;
      }
      this.status = this.inferredStatus;
    }
  }
  ngOnInit() {
  }

  isNotNil<T>(value: T): value is NonNullable<T> {
    return typeof value !== 'undefined' && value !== null;
  }

}
